import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { useLang, scrollToId } from "@/i18n";

// Butoane plutitoare secundare: marker Via Transilvanica + "inapoi sus".
// Stau deasupra butonului de WhatsApp (care e bottom-right).
export default function FloatingTools() {
  const { t } = useLang();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-[92px] right-7 z-[59] flex flex-col items-center gap-3">
      <AnimatePresence>
        {showTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.6 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top"
            aria-label="Înapoi sus"
            className="w-11 h-11 rounded-full bg-cream-light border border-warm-grey/60 text-brown shadow-lg flex items-center justify-center hover:text-terracotta hover:border-terracotta transition-colors"
          >
            <ArrowUp size={18} />
          </motion.button>
        )}
      </AnimatePresence>

      <motion.button
        initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2.4, type: "spring", stiffness: 200 }}
        onClick={() => { scrollToId("#via-transilvanica"); setTimeout(() => scrollToId("#via-transilvanica"), 900); setTimeout(() => scrollToId("#via-transilvanica"), 1800); }}
        data-testid="vt-float"
        aria-label={t("vt.eyebrow")}
        title={t("vt.eyebrow")}
        className="group relative w-12 h-12 rounded-2xl overflow-hidden shadow-lg hover:scale-105 hover:shadow-xl transition-all duration-300"
      >
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-main text-cream text-xs font-semibold rounded-full px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Via Transilvanica
        </span>
        <img src="/assets/vt-logo.png" alt="Via Transilvanica" className="w-full h-full object-cover" />
      </motion.button>
    </div>
  );
}
